import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "memory-editor" }
const _hoisted_2 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "Add memory", -1 /* HOISTED */)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "description" }, "Add something you'd like the agent to remember", -1 /* HOISTED */)),
    _createVNode(_component_TextArea, {
      ref: "textarea",
      modelValue: $data.draft,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.draft) = $event)),
      class: "textarea",
      maxlength: $props.symbolLimit,
      rows: 8,
      disabled: $options.disabled,
      placeholder: $options.placeholder
    }, null, 8 /* PROPS */, ["modelValue", "maxlength", "disabled", "placeholder"]),
    _createElementVNode("div", _hoisted_2, [
      ($data.draft || $data.editing_index !== undefined)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            tiny: "",
            disabled: $props.saving,
            onClick: $options.onDiscard
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Discard ")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled", "onClick"]))
        : _createCommentVNode("v-if", true),
      ($data.editing_index !== undefined)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            tiny: "",
            primary: "",
            disabled: !$options.can_save,
            loading: $props.saving,
            onClick: $options.onSave
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Save ")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled", "loading", "onClick"]))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 2,
            tiny: "",
            primary: "",
            disabled: !$options.can_add,
            loading: $props.saving,
            onClick: $options.onAdd
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Add ")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled", "loading", "onClick"]))
    ])
  ]))
}